import { Files } from "lucide-react";

export function DragDropOverlay({
  isDragging,
  onDragEnter,
  onDragOver,
  onDragLeave,
  onDrop,
}) {
  if (!isDragging) return null;

  return (
    <div
      className="absolute inset-0 z-50 flex items-center justify-center bg-blue-900/90 border-2 border-dashed border-blue-400/70 rounded-xl backdrop-blur-sm drag-overlay-enter"
      onDragEnter={onDragEnter}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
    >
      <div className="flex flex-col items-center justify-center pointer-events-none">
        <div className="flex items-center mb-6 pointer-events-none">
          <Files className="h-6 w-6 text-blue-400 mr-2" />
          <p className="text-blue-300 text-lg font-medium">
            Drop files here to add
          </p>
        </div>

        <div className="flex items-center gap-2 pointer-events-none">
          <div className="bg-white dark:bg-white/90 w-10 h-12 rounded-sm shadow-sm flex items-center justify-center">
            <span className="text-gray-500 text-xs font-mono">TXT</span>
          </div>
          <div className="bg-blue-500 text-white text-xs py-1 px-2 rounded-full whitespace-nowrap">
            <span className="text-white/90 text-xs">file.txt</span>
          </div>
        </div>
      </div>
    </div>
  );
}
